import { useMediaScreenMax } from "@xo-union/tk-ui-breakpoints";
const useIsModalBreakpoint = () => useMediaScreenMax('xs').yes;
export default useIsModalBreakpoint;